

// Get the toggle switch element
const darkModeToggle = document.getElementById('dark-mode-toggle');

// Check if dark mode is already enabled
const isDarkModeEnabled = () => {
  return document.body.classList.contains('dark-mode');
};

// Enable dark mode
const enableDarkMode = () => {
  document.body.classList.add('dark-mode');
  localStorage.setItem('darkModeEnabled', true);
  darkModeToggle.checked = true; // Set the toggle switch to checked when dark mode is enabled
  document.documentElement.setAttribute('data-theme', 'dark'); // Add a data-theme attribute to the root element
  document.getElementById('mode-indicator').textContent = "Dark Mode Enabled"; // Update the mode indicator text
};

// Disable dark mode
const disableDarkMode = () => {
  document.body.classList.remove('dark-mode');
  localStorage.removeItem('darkModeEnabled');
  darkModeToggle.checked = false; // Set the toggle switch to unchecked when dark mode is disabled
  document.documentElement.setAttribute('data-theme', 'light'); // Add a data-theme attribute to the root element
  document.getElementById('mode-indicator').textContent = "Light Mode Enabled"; // Update the mode indicator text
};

// Toggle dark mode
const toggleDarkMode = () => {
  if (isDarkModeEnabled()) {
    disableDarkMode();
  } else {
    enableDarkMode();
  }
};

// Set the initial state of the toggle switch
darkModeToggle.checked = isDarkModeEnabled();

// Listen for clicks on the toggle switch
darkModeToggle.addEventListener('click', toggleDarkMode);

// Listen for changes to the system's color scheme
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
  if (localStorage.getItem('darkModeEnabled') === null) {
    toggleDarkMode();
  }
});

// Check if user's preference for dark mode is stored in local storage
if (localStorage.getItem('darkModeEnabled') === 'true') {
    enableDarkMode();
} else {
 disableDarkMode(); // Set the initial mode to light mode
}


